import { AxiosResponse } from 'axios';
import BaseApi from './BaseApi';
import { IGroupBookingSurvey } from '../Models/IGroupBookingSurvey';

/**
 * The SurveysApi class.
 *
 */
class SurveysApi extends BaseApi {
	constructor() {
        super('surveys');
	}
	
	/** 
	 * Send Group survey
	 *  
	 * @return {Promise} The request promise.
	*/
	public createGroupSurvey = (survey: IGroupBookingSurvey): Promise<AxiosResponse> => {		
		return this._post('group', survey);
	}

	/** 
	 * Send Group survey
	 *  
	 * @return {Promise} The request promise.
	*/
	public hasAnswered = (bookingId: string): Promise<AxiosResponse> => {		
		return this._get('hasanswered', {
			bookingId
		});
	}
	
}

export default SurveysApi;